export default __webpack_public_path__ + "static/media/avatar_alison5.a30546cd.mp3";